export default __webpack_public_path__ + "static/media/indimg4.31ca3f51.webp";